/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbSharedRefineMenuFilterRingSize_viewer = {
    readonly isRingSizesFilterOn: boolean | null;
    readonly " $refType": "SbSharedRefineMenuFilterRingSize_viewer";
};
export type SbSharedRefineMenuFilterRingSize_viewer$data = SbSharedRefineMenuFilterRingSize_viewer;
export type SbSharedRefineMenuFilterRingSize_viewer$key = {
    readonly " $data"?: SbSharedRefineMenuFilterRingSize_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRefineMenuFilterRingSize_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedRefineMenuFilterRingSize_viewer",
  "selections": [
    {
      "alias": "isRingSizesFilterOn",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "ringSizesFilter"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"ringSizesFilter\")"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
(node as any).hash = '91fa787e4449377b67fae79997fdc23a';
export default node;
